import React, { useState } from "react";
import { FaLock, FaUserMd, FaClipboardList, FaMinus, FaPlus, FaFileMedical, FaServer, FaShieldAlt } from "react-icons/fa";
import { AiOutlineApi, AiOutlineSafetyCertificate, AiOutlineAppstore } from "react-icons/ai";
import { MdSecurity, MdIntegrationInstructions } from "react-icons/md";
import { FaUsersCog, FaUserShield, FaHandshake, FaRegLightbulb, FaRegCheckCircle } from "react-icons/fa";
import Medpalm from "../../../assests/cmsblue.jpg";
import { motion } from "framer-motion";
import Footer from "../../../Component/Fooder";
const services = [
  {
    "title": "Healthcare Interoperability Strategy Development",
    "description": "Develop a comprehensive strategy to enhance healthcare data exchange, improve system integrations, and optimize operational efficiency. Streamline workflows, enable faster client onboarding, reduce integration costs, and ensure compliance with HIPAA and other healthcare regulations for secure and seamless data sharing."
  },
  {
    "title": "Healthcare Interoperability Roadmapping",
    "description": "Create a structured roadmap with defined milestones, technology adoption plans, and best practices to achieve seamless interoperability. Assess system capabilities, identify integration challenges, and establish key objectives to ensure long-term success in health data exchange."
  },
  {
    "title": "Healthcare Data Mapping and Workflow Documentation",
    "description": "Standardize and optimize data flow across multiple healthcare systems using structured data mapping techniques. Document workflows to enhance efficiency, reduce errors, and improve data accessibility for healthcare providers, ensuring smooth information exchange and better patient care."
  },
  {
    "title": "Healthcare Interoperability Training and Education",
    "description": "Provide expert training on interoperability standards such as FHIR and HL7 for healthcare professionals, IT teams, and administrators. Offer in-depth knowledge on regulatory compliance, technical implementation, and best practices to facilitate seamless healthcare data integration and interoperability."
  },
  {
    "title": "EHR Integration Planning",
    "description": "Strategically plan and implement EHR system integrations using industry-leading interoperability standards such as FHIR and HL7. Ensure seamless connectivity with third-party applications, hospital networks, and healthcare providers to enhance care coordination and improve data accessibility."
  },
  {
    "title": "FHIR and HL7 Implementation Support",
    "description": "Support healthcare organizations in implementing FHIR and HL7 protocols to standardize health data exchange. Provide technical assistance for seamless API integrations, ensure regulatory compliance, and enable interoperability between disparate healthcare systems."
  },
  {
    "title": "API Development for Healthcare Interoperability",
    "description": "Design and develop secure, scalable APIs to facilitate real-time healthcare data exchange. Enable seamless system communication while ensuring data security, interoperability, and compliance with industry regulations such as HIPAA and ONC Cures Act requirements."
  },
  {
    "title": "HIPAA & Compliance Consulting",
    "description": "Ensure full compliance with HIPAA, CMS, GDPR, and other healthcare data regulations. Conduct risk assessments, implement robust security measures, and provide expert guidance on regulatory best practices to safeguard patient information and maintain secure healthcare interoperability solutions."
  }
]

const features = [
  { text: "Secure API for patient-controlled data sharing.", icon: <AiOutlineApi className="text-[#2a627a] text-xl" /> },
  { text: "Real-time access to Medicare claims and records.", icon: <AiOutlineSafetyCertificate className="text-[#2a627a] text-xl" /> },
  { text: "Integration with third-party healthcare applications.", icon: <AiOutlineAppstore className="text-[#2a627a] text-xl" /> },
  { text: "Improved security with OAuth 2.0 authentication.", icon: <MdSecurity className="text-[#2a627a] text-xl" /> },
  { text: "Customizable access permissions for patient privacy.", icon: <FaUsersCog className="text-[#2a627a] text-xl" /> },
  { text: "Seamless interoperability with EHR systems.", icon: <MdIntegrationInstructions className="text-[#2a627a] text-xl" /> },
];

const benefits = [
  { text: "Reduces administrative burden on healthcare providers.", icon: <FaUserShield className="text-[#2a627a] text-xl" /> },
  { text: "Enhances patient engagement and self-management.", icon: <FaHandshake className="text-[#2a627a] text-xl" /> },
  { text: "Promotes innovation in digital health applications.", icon: <FaRegLightbulb className="text-[#2a627a] text-xl" /> },
  { text: "Increases transparency and trust in health data sharing.", icon: <MdSecurity className="text-[#2a627a] text-xl" /> },
  { text: "Ensures compliance with CMS regulations for secure data handling.", icon: <AiOutlineSafetyCertificate className="text-[#2a627a] text-xl" /> },
  { text: "Facilitates seamless interoperability with healthcare systems.", icon: <FaRegCheckCircle className="text-[#2a627a] text-xl" /> },
];
const cmsFeatures = [
  { icon: <FaLock className="text-[#2a627a] text-lg" />, text: "Supports secure data exchange under CMS regulations." },
  { icon: <FaClipboardList className="text-[#2a627a] text-lg" />, text: "Uses FHIR standards for structured and standardized health data." },
  { icon: <FaUserMd className="text-[#2a627a] text-lg" />, text: "Enhances patient access to personal health information." },
  { icon: <FaFileMedical className="text-[#2a627a] text-lg" />, text: "Ensures interoperability between different EHR systems." },
  { icon: <FaServer className="text-[#2a627a] text-lg" />, text: "Facilitates seamless data sharing across healthcare providers." },
  { icon: <FaShieldAlt className="text-[#2a627a] text-lg" />, text: "Strengthens patient data privacy with robust security measures." },
];

const BlueButton = () => {
  const [openIndex, setOpenIndex] = useState(0);
  return (
    <>
      <div className="min-h-screen mt-10 p-8 bg-white w-full flex flex-col items-center shadow-lg rounded-lg">
        {/* <div className="min-h-screen mt-10 p-8 bg-gradient-to-t from-[#78ffa5] to-[#03ab3b] w-full flex flex-col items-center shadow-lg rounded-lg"> */}
        {/* Header Section */}
        <div className=" text-center w-full">
          <h1 className="font-semibold text-[30px] flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">Blue Button 2.0 - <span className="text-gray-800">CMS Mandates</span> </h1>
          <p className="text-gray-800 mt-3 text-sm">
            Enabling healthcare interoperability and secure patient data access as per CMS guidelines.
          </p>
        </div>

        {/* What is Blue Button 2.0? */}
        <section className="mt-8 flex flex-col md:flex-row  bg-gray-300 p-6 bg-opacity-80 drop-shadow-2xl rounded-xl items-center">
          <img draggable={false}src={Medpalm} alt="Healthcare Tech" className="rounded-lg shadow-xl  w-full md:w-1/5" />
          <div className="md:ml-6 mt-2 md:mt-0">
            <h2 className="text-[30px] font-extrabold text-[#2a627a]">What is Blue Button 2.0?</h2>
            <p className="text-gray-800 mt-2 text-sm text-wrap">
              Blue Button 2.0 is a secure API that allows Medicare beneficiaries to connect their health data
              with third-party applications, ensuring seamless access while complying with FHIR standards.
            </p>
          </div>
        </section>

        {/* Role in CMS Compliance */}
        <section className="mt-8 w-full">
          <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 p-2">
            Role in CMS Compliance
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
            {cmsFeatures.map((item, index) => (
              <motion.div
                key={index}
                className="flex items-center space-x-3 bg-gray-300 bg-opacity-100 p-4 rounded-lg shadow"
                initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                viewport={{ once: false, amount: 0.3 }}
              >
                {item.icon}
                <span className="text-gray-800 text-sm font-medium">{item.text}</span>
              </motion.div>
            ))}
          </div>
        </section>

        {/* Key Features Section */}
        <section className="mt-6 w-full">
          <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800 p-2">
            Key Features
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
            {features.map((item, index) => (
              <motion.div
                key={index}
                className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow"
                initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                whileInView={{ opacity: 1, x: 0 }} // Move to center
                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                viewport={{ once: false, amount: 0.3 }}
              >
                {item.icon}
                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
              </motion.div>
            ))}
          </div>
        </section>


        {/* Benefits Section */}
        <section className="mt-8 w-full">
          <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
            Benefits
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
            {benefits.map((item, index) => (
              <motion.div key={index} className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow" initial={{ opacity: 0, scale: 0.8, y: 40 }}
                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                viewport={{ once: false, amount: 0.3 }}>

                {item.icon}
                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
              </motion.div>
            ))}
          </div>
        </section>




        {/* Services Section */}
        <section className="mt-12 w-full  mx-auto">
          {/* Heading */}
          <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">
            Discover Our Services
          </h2>

          {/* Service List */}
          <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
            {services.map((service, index) => (
              <div key={index} className="border-b border-gray-800">
                {/* Service Title */}
                <button
                  className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                  onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                >
                  {service.title}
                  {openIndex === index ? (
                    <FaMinus className="text-red-500" />
                  ) : (
                    <FaPlus className="text-gray-600" />
                  )}
                </button>

                {/* Service Description (Expandable with Animation) */}
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                  transition={{ duration: 0.3, ease: "easeInOut" }}
                  className="overflow-hidden"
                >
                  <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                </motion.div>
              </div>
            ))}
          </div>
        </section>

      </div>
      <Footer />
    </>
  );
};

export default BlueButton;
